import { createSlice } from "@reduxjs/toolkit";

let initialState = { dialogDetailOpen: false };


const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: initialState,
  reducers: {
    setDialogDetailOpen: (state, action) => {
      state.dialogDetailOpen = action.payload
    },
  },
  extraReducers: (builder) => {

  },
});

export const {
  setDialogDetailOpen
} = dashboardSlice.actions;


export default dashboardSlice.reducer;
